import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-people" }
const _hoisted_2 = { class: "col-signals" }
const _hoisted_3 = { class: "dots-button pointer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_CompanyTile = _resolveComponent("CompanyTile")
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseNum = _resolveComponent("PulseNum")
  const _component_TrackerSelect = _resolveComponent("TrackerSelect")
  const _component_ContactItem = _resolveComponent("ContactItem")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row-container pointer", {highlight: $options.highlight}])
  }, [
    _createVNode(_component_Divider, {
      m: "0",
      class: "center"
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["row-grid", {hover: $props.chosenId === $props.item.id}])
    }, [
      _createVNode(_component_CompanyTile, {
        class: "col-company",
        logo: $props.item.logo_url,
        name: $props.item.name,
        type: $props.item.type
      }, null, 8 /* PROPS */, ["logo", "name", "type"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "people-button add-person",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.trackPerson && $options.trackPerson(...args)), ["stop"]))
        }, [
          _createVNode(_component_Icon, {
            icon: "user-plus",
            size: "1.6rem",
            stroke: "var(--brand-500)",
            "stoke-width": "1"
          })
        ]),
        _createVNode(_component_PulseNum, {
          loading: $options.loading_contacts,
          selected: !!$options.contacts,
          count: $options.people,
          disabled: $options.search_contacts,
          max: 50
        }, null, 8 /* PROPS */, ["loading", "selected", "count", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PulseNum, {
          count: $props.item.signals,
          max: 100,
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($props.item.signals && _ctx.$dispatch('set-entity', $props.item.shared_company_id)), ["stop"]))
        }, null, 8 /* PROPS */, ["count"])
      ]),
      _createElementVNode("div", {
        class: "col-actions",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_TrackerSelect, { options: $data.TRACKER_OPTS }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Icon, {
                icon: "ellipsis-01",
                size: "1.6rem",
                fill: "var(--brand-400)"
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["options"])
      ])
    ], 2 /* CLASS */),
    _createVNode(_component_CollapseGroup, {
      name: "list",
      items: $options.contacts,
      duration: 300
    }, {
      default: _withCtx(({item: contact}) => [
        (_openBlock(), _createBlock(_component_ContactItem, {
          key: contact.id,
          contact: contact,
          "company-id": $props.item.id,
          class: _normalizeClass([{hover: $props.chosenId === contact.id}, "contact"]),
          "tracker-width": $props.trackerWidth,
          onClick: _withModifiers($event => (_ctx.$debounce_175($options.editPerson, contact.id)), ["stop"])
        }, null, 8 /* PROPS */, ["contact", "company-id", "class", "tracker-width", "onClick"]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["items"]),
    _createVNode(_component_TrackerDelete, { ref: "delete" }, null, 512 /* NEED_PATCH */)
  ], 2 /* CLASS */))
}